module.exports = __webpack_public_path__ + "img/shangjia.3df7dfa0.png";